var COLUMN_ORDER: string[] =  [
    "name",
    "level",
    'sd blanks',
    'lod',
    'loq',
    "expected concentration",
    "parallel",
    "tr",
    "change tr",
    "rsd tr",
    "mean change tr",
    "rsd change tr",
    "area",
    "mean area",
    "sd area",
    "rsd area",
    "n",
    "change n",
    "mean change n",
    "rsd change n",
    "mass",
    "precursor ion",
    "product ion",
    "rs",
    "change (rₛ)",
    "mean change rs",
    "rsd change rs",
    "as",
    "change as",
    "mean change as",
    "rsd change as",
    "k",
    "change k",
    "mean change k",
    "rsd change k",
    "experimental concentration",
    "mean experimental concentration",
    "sd experimental concentration",
    "rsd experimental contentration",
    "residual",
    "bc concentration",
    "bc concentration error",
    "trueness",
    "mean trueness",
    "sd trueness",
    "rsd trueness",
    "is area",
    "is expected concentration",
    "is area ratio",
    "is expected concentration ratio",
    "slope",
    "sd slope",
    "intercept",
    "sd intercept",
    "rsquared",
    "rss",
    "ccα",
    "ccβ",
    "y critical",
    "sum sq dev",
    "deg freedom",
    "t coef",
    "noncent coef",
    "xd[0]",
    "xd[1]",
    "xd[2]",
    "xd[3]",
    "weight sum sq dev",
    "s",
    "sigma[1]",
    "sigma[2]",
    "sigma[3]",
    "sd xd[0]",
    "sd xd[1]",
    "sd xd[2]",
    "sd xd[3]",
    "sigma0",
    "d"
    ];

export default COLUMN_ORDER;